<template>
  <SSOBody />
</template>

<script>
import SSO from "../components/mixins/SSO";
import SSOBody from "../components/misc/SSOBody";
import { mapActions } from "vuex";
export default {
  name: "ValidateJWT",
  mixins: [SSO],
  components: { SSOBody },
  methods: {
    ...mapActions(["validateJWT"]),
    startupTask() {
      return this.validateJWT(this.$route.query);
    }
  }
};
</script>